import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UsePetitionStrengthScoreReturn = ModelHookResult<
	{
		score: number;
		petitionStrengthUrl: string;
	},
	{
		improveStrengthLinkClick: () => void;
	}
>;

export function usePetitionStrengthScore(): UsePetitionStrengthScoreReturn {
	const track = useTracking();

	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const improveStrengthLinkClick = useCallback(() => {
		void track('petition_manage_strength_click', {
			score: petition.score,
		});
	}, [track, petition.score]);

	return {
		data: {
			score: petition.score,
			petitionStrengthUrl: `/p/${petition.slug}/edit`,
		},
		actions: {
			improveStrengthLinkClick,
		},
	};
}
